import { Axios } from 'axios'

import { config } from '@percent/workplace-giving/config/config'

const url = `https://api.ipgeolocation.io/ipgeo${config.keys.geolocation ? `?apiKey=${config.keys.geolocation}` : ''}`

const TIMEOUT = 2 * 1000

export type GetGeolocationDataResponse = {
  time_zone?: {
    name: string
  }
  country_code3: string
  state_code?: string
}

export const getGeolocationData = async (client: Axios) =>
  client
    .get<GetGeolocationDataResponse>(url, {
      timeout: TIMEOUT,
      validateStatus: null
    })
    .then(r =>
      r.status === 200
        ? {
            countryCode: r.data.country_code3,
            timeZone: r.data.time_zone?.name,
            stateCode: r.data.state_code
          }
        : undefined
    )
    .catch(() => undefined)
